import { render, staticRenderFns } from "./InsNavLayout.vue?vue&type=template&id=4706d3c3&scoped=true"
import script from "./InsNavLayout.vue?vue&type=script&lang=ts"
export * from "./InsNavLayout.vue?vue&type=script&lang=ts"
import style0 from "./InsNavLayout.vue?vue&type=style&index=0&id=4706d3c3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706d3c3",
  null
  
)

export default component.exports